import React, { useEffect, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionAction } from '../../../Actions/option';
import { decreamentScale, increamentScale } from '../../../Actions/scale';
import { setLoading } from '../../../Actions/setLoading';
import { sendFeature, sendRotate, sendScale } from '../../../utils/sendFeature';
import { isEmpty } from 'lodash';
import { ChangeRotate } from '../../../Actions/rotate';

const Tools = () => {
    //all state
    const tools = useSelector(state => state.feature);
    const picState = useSelector(state => state.picture);
    const scale = useSelector(state => state.scale);
    const option = useSelector(state => state.option);
    const rotate = useSelector(state => state.rotate);
    //use useRef hook for stop call function at first rendering
    const scaleDidMount = useRef(false);
    const rotateDidMount = useRef(false);
    const featureDidMount = useRef(false);
    const dispatch = useDispatch();


    //use useEffect hook for send updated state after dispatch
    useEffect(()=>{
        if ( !scaleDidMount.current ) {
            return scaleDidMount.current = true;
        }
        handleScale();
    },[scale]);

    useEffect(()=>{
        if ( !rotateDidMount.current ) {
            return rotateDidMount.current = true;
        }
        handleFeature();
    },[option]);

    useEffect(()=>{
        if ( !featureDidMount.current ) {
            return featureDidMount.current = true;
        }
        handleRotate();
    },[rotate]);
    
    //all function to send all state to server 
    const handleRotate = () =>{
        dispatch(setLoading());
        sendRotate(option,rotate,scale,tools.featur_value,picState.token,picState.procode,picState.object_id);
    }
    const handleScale = () => {
        dispatch(setLoading());
        sendScale(option,scale,tools.featur_value,picState.token,picState.procode,picState.object_id);
    }
    const handleFeature = () => {
        if (Object.keys(option).length > 0) {
            dispatch(setLoading());
            sendFeature(option,rotate,scale,tools.featur_value,picState.token,picState.procode,picState.object_id);
        }
    }



    return ( 
        <>
            <div className='w-100 py-2'>
                <div className='w-100 d-flex flex-wrap'>
                    {isEmpty(tools) ? "" : Object.keys(tools.translate).map(x => (
                        <div className='w-50 mb-2 px-1'>
                            <Form.Select className='w-100 text-center px-1' onChange={(e) => {
                                if(!isEmpty(e.target.options[e.target.selectedIndex].value)){
                                    dispatch(setOptionAction(e.target.options[e.target.selectedIndex].value));
                                }
                            }}>
                                <option className='shadow-sm' disabled value="" style={{width:"90%"}} variant="light">
                                    {x}
                                </option>
                                {Object.values(tools.translate[x]).map(y => (
                                    <option className='text-dark text-center' value={`${x}:${y}`}>{y}</option>
                                ))}
                            </Form.Select>
                        </div>
                    ))}
                </div>
                <div className='sc-rt-container w-100'>
                    <div className='scale-wrapper'>
                        <Button variant='light' onClick={() => {
                            dispatch(decreamentScale());
                        }}><i class="bi bi-zoom-out"></i></Button>
                        <Button variant='light' onClick={() => {
                            dispatch(increamentScale());
                        }}><i class="bi bi-zoom-in"></i></Button>
                    </div>
                    <div className='rotate-wrapper'>
                        <Button variant='light' onClick={() => {
                            dispatch(ChangeRotate());
                        }}><i className='fa fa-rotate-left me-3'></i>چرخاندن</Button>
                    </div>
                </div>

            </div>
        </>
    );
}
 
export default Tools;